<div class="toast {{toasterClass}} mx-auto" id="basic-primary-example" role="alert" aria-live="assertive"
    aria-atomic="true">
    <div class="toast-header text-white {{toasterClass}}">
        <strong class="me-auto">{{title}}</strong>
        <button type="button" class="btn-close btn-close-white" aria-label="Close"
            (click)="notificationRef.close()"></button>
    </div>
    <div class="toast-body text-white">{{message}}</div>
</div>